const PRE_HEADER_SPACE_VAR = "--pre-header-space";
const MARQUEE_MQ = "(max-width: 767px)";
const CLONE_ATTR = "data-pre-header-marquee-clone";

function updatePreHeaderSpace(preHeader, body) {
  const height =
    preHeader.getBoundingClientRect().height || preHeader.offsetHeight || 0;

  if (height > 0) {
    body.style.setProperty(PRE_HEADER_SPACE_VAR, `${height}px`);
  }
}

function updateMarqueeLoopDistance(track) {
  const firstOriginal = track.querySelector(
    `.pre-header__item:not([${CLONE_ATTR}])`,
  );
  const firstClone = track.querySelector(`[${CLONE_ATTR}]`);
  if (!firstOriginal || !firstClone) {
    return;
  }

  const loopPx =
    firstClone.getBoundingClientRect().left -
    firstOriginal.getBoundingClientRect().left;

  if (loopPx > 0) {
    track.style.setProperty(
      "--pre-header-marquee-distance",
      `${Math.round(loopPx * 1000) / 1000}px`,
    );
  }
}

function teardownMarquee(viewport, track) {
  track.style.removeProperty("--pre-header-marquee-distance");
  track.querySelectorAll(`[${CLONE_ATTR}]`).forEach((node) => node.remove());
  delete track.dataset.marqueeDuplicated;
  viewport.classList.remove("pre-header__viewport--marquee");
}

function setupMarquee(viewport, track) {
  if (!track.dataset.marqueeDuplicated) {
    const originals = track.querySelectorAll(
      `.pre-header__item:not([${CLONE_ATTR}])`,
    );
    originals.forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute(CLONE_ATTR, "");
      track.appendChild(clone);
    });
    track.dataset.marqueeDuplicated = "true";
  }

  viewport.classList.add("pre-header__viewport--marquee");
  track.getBoundingClientRect();
  updateMarqueeLoopDistance(track);
}

function bindPreHeaderSpaceUpdates(preHeader, body) {
  const scheduleUpdate = () => {
    requestAnimationFrame(() => updatePreHeaderSpace(preHeader, body));
  };

  scheduleUpdate();

  if (typeof ResizeObserver !== "undefined") {
    const ro = new ResizeObserver(scheduleUpdate);
    ro.observe(preHeader);
  } else {
    window.addEventListener("resize", scheduleUpdate);
  }

  window.addEventListener("load", scheduleUpdate);

  return scheduleUpdate;
}

export function initPreHeaderSpace() {
  const preHeader = document.querySelector(".pre-header");
  const { body } = document;
  if (!preHeader || !body) return;

  bindPreHeaderSpaceUpdates(preHeader, body);
}

export function initPreHeaderMarquee() {
  const root = document.querySelector(".js-pre-header");
  if (!root) return;

  const viewport = root.querySelector(".pre-header__viewport");
  const track = root.querySelector(".pre-header__track");
  if (!viewport || !track) return;

  const mobileQuery = window.matchMedia(MARQUEE_MQ);
  let layoutObserver = null;

  const disconnectLayoutObserver = () => {
    if (layoutObserver) {
      layoutObserver.disconnect();
      layoutObserver = null;
    }
  };

  const bindLayoutObserver = () => {
    disconnectLayoutObserver();
    if (typeof ResizeObserver === "undefined") {
      return;
    }
    layoutObserver = new ResizeObserver(() => {
      updateMarqueeLoopDistance(track);
    });
    layoutObserver.observe(track);
  };

  const scheduleSpaceUpdate = bindPreHeaderSpaceUpdates(root, document.body);

  const applyMode = () => {
    if (mobileQuery.matches) {
      setupMarquee(viewport, track);
      bindLayoutObserver();
    } else {
      disconnectLayoutObserver();
      teardownMarquee(viewport, track);
    }
    scheduleSpaceUpdate();
  };

  applyMode();

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", applyMode);
  } else {
    mobileQuery.addListener(applyMode);
  }

  window.addEventListener("load", applyMode);
}
